import api from 'ApiConfig';

const resumeService = {
  // 📥 Get all student resumes (filters: search, hrId, companyId, branchId, resumeType, page, limit)
  getAllResumes: async (params) => {
    return api.get('/superadmin/resumes', { params });
  },

  // 📄 Get HR / Company / Branch options for the filters
  getResumeFilters: async () => {
    return api.get('/superadmin/resume-filters');
  },
};

export default resumeService;
